"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

class Icon extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);


    }

    connectedCallback() {
        if (this.animate) {
            setTimeout(function () {
                this.root.querySelector("img").classList.add("animate");
            }.bind(this), 100)
        }
    }

    get animate() {
        return this.hasAttribute("animate");
    }
    set animate(animate) {
        this.setAttribute("animate", "");
    }

}

window.customElements.define("swiftref-icon", Icon);

module.exports = Icon;
